module.exports = __webpack_public_path__ + "img/vuexy-logo.152cf9ea.png";